import React, { useEffect, useState } from 'react';
import './distributer.css';
import api from '../../axiosInstance';
import idCard from '../../Assets/ProviderImage/id-card.png';
import EmailImage from '../../Assets/ProviderImage/envelope.png';
import PhoneImage from '../../Assets/ProviderImage/telephone.png';
import IDCArdNo from '../../Assets/ProviderImage/id-card_number.png';
import address from '../../Assets/ProviderImage/location.png';

function DistributorComponent() {
  const parent_id = sessionStorage.getItem('providerId');
  const [providerData, setProviderData] = useState({});

  useEffect(() => {
    getProvider();
  }, []);

  const getProvider = async () => {
    try {
      const response = await api.get(`/distributor/${parent_id}`);
      if (response?.status === 200) {
        setProviderData(response?.data?.data);
        console.log(response?.data?.data);
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <div className='distributerfont'>
      <div className='row'>
        <div className='col-md-12 col-12'>
          <h3 className='distributerfont'>Provider</h3>
          <div className='distributerbgimage rounded-3 shadow p-3'>
            <div className='formwidthBgImage shadow rounded-3'>
              <div className='provider-info distributerfontHeading'>
              <div className='d-flex p-4'>
                  <img src={IDCArdNo} width={40} className="m-2" alt="ID Card" />
                  <div className='d-flex align-items-center'>
                    <h5 className='mb-0 p-1'>ID: </h5>
                    <h5 className='mb-0 p-1'>{providerData?.distri_ID}</h5>
                  </div>
                </div>
                <div className='d-flex p-4'>
                  <img src={idCard} width={40} className="m-2" alt="ID Card" />
                  <div className='d-flex align-items-center'>
                    <h5 className='mb-0 p-1'>Name: </h5>
                    <h5 className='mb-0 p-1'>{providerData?.name}</h5>
                  </div>
                </div>
                <div className='d-flex p-4'>
                  <img src={EmailImage} width={40} className="m-2" alt="Email" />
                  <div className='d-flex align-items-center'>
                    <h5 className='mb-0 p-1'>Email: </h5>
                    <h5 className='mb-0 p-1'>{providerData?.email}</h5>
                  </div>
                </div>
                <div className='d-flex p-4'>
                  <img src={PhoneImage} width={40} className="m-2" alt="Phone" />
                  <div className='d-flex align-items-center'>
                    <h5 className='mb-0 p-1'>Phone: </h5>
                    <h5 className='mb-0 p-1' style={{fontFamily:'cursive'}}>{providerData?.phone}</h5>
                  </div>
                </div>
                <div className='d-flex p-4'>
                  <img src={address} width={40} className="m-2" alt="Address" />
                  <div className='d-flex align-items-center'>
                    <h5 className='mb-0 p-1'>Address: </h5>
                    <h5 className='mb-0 p-1'>{providerData?.address}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='col-md-3 col-12 distributerSideimage rounded-5 mt-md-0 mt-2 distributerfont'>
          <div className='bg-white my-4 mx-2 p-3 rounded-5'>
            <h5>Details</h5>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium vel harum tempore eaque asperiores? Delectus voluptatum eligendi tempore fugit labore, officiis reiciendis, deserunt sunt cupiditate, minus sed omnis eveniet.</p>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default DistributorComponent;
